import OnboardingScreen from 'features/onboarding/screens/OnboardingScreen/OnboardingScreen';
import React from 'react';

export default function OnboardingPage() {
  return <OnboardingScreen />;
}
